import { Button } from '@/components/base/Button';
import { t } from '@/messages/zh-TW';
import { ModalFrame } from '../ModalFrame';

/**
 * 共用對話框 ①：破壞性操作確認。
 *
 * 原系統函式：`sysConfirm(msg, callbackYes, callbackNo)`，`js-my/common.js:356-379`
 *   `:359` `closeIcon: false`      ← **不能用 × 關掉**，必須明確選一邊
 *   `:360` `icon: 'fa fa-info-circle'`
 *   `:361` `title: msg`            ← **訊息本身就是標題**
 *   `:362` `type: 'red'`
 *   `:363` `content: false`        ← 沒有 body
 *   `:366-372` 按鈕 `'確定'` → callbackYes、`:373-376` `'取消'` → callbackNo
 * 呼叫範例：`common.js:1102` `sysConfirm('是否確定要刪除檔案?', function(){ … })`
 * 另有 `common.sysConfirm` 包裝（`:128-130`）。
 *
 * `AUDIT_GATE3_HANDOFF.md` §1.1：這個對話框在全部線稿中未入稿。
 *
 * 【證據等級】§7 第 3 級（原始碼）。【雛形值待實機校準】
 */
export interface ConfirmDialogProps {
  uiId: string;
  open: boolean;
  /** 訊息＝標題（common.js:361,363）。 */
  message: string;
  onConfirm(): void;
  onCancel(): void;
}

export function ConfirmDialog({ uiId, open, message, onConfirm, onCancel }: ConfirmDialogProps) {
  return (
    <ModalFrame
      uiId={uiId}
      open={open}
      title={message}
      tone="danger"
      // common.js:359 closeIcon: false —— 沒有 ×，Esc 與點遮罩也不關閉。
      dismissible={false}
      onClose={onCancel}
      footer={
        <>
          <Button
            uiId={`${uiId}-confirm`}
            variant="primary"
            size="sm"
            type="button"
            onClick={onConfirm}
          >
            {t('action.confirm')}
          </Button>
          <Button
            uiId={`${uiId}-cancel`}
            variant="default"
            size="sm"
            type="button"
            onClick={onCancel}
          >
            {t('action.cancel')}
          </Button>
        </>
      }
    />
  );
}
